export enum IWalletEntityType {
  event = 'EVENT',
  event_collection = 'EVENT_COLLECTION',
  good_service = 'GOOD_SERVICE',
}

export enum IWalletScreen {
  tickets = 'tickets',
  good_service = 'extra',
}

export interface IWalletEvent {
  id: number
  type: IWalletEntityType
  count: number
}

export interface IWalletEventMetadata {
  currentPage: number
  hasMorePages: boolean
}

export interface IWalletEventTicketCode {
  cod: string
}

export const MAX_WALLET_EVENTS_REQUESTS_SIZE = 10
